var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e8b923",
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "medal1"), /*#__PURE__*/React.createElement("path", {
    d: "M 9.193 20.037 c -1.25 0 -1.416 -0.584 -1.416 -0.584 l -4.875 9.58 l 3.909 -0.438 l 2.162 3.25 c 0 0 4.5 -9.393 4.5 -9.33 c -2.33 -0.056 -1.405 -2.415 -4.28 -2.478 z M 20.182 21.065 c 0.607 -1.02 1.504 -1.537 2.691 -1.553 s 1.787 -0.617 1.803 -1.804 c 0.016 -1.186 0.533 -2.083 1.553 -2.689 s 1.24 -1.428 0.66 -2.463 s -0.58 -2.071 0 -3.106 s 0.359 -1.856 -0.66 -2.463 s -1.537 -1.503 -1.553 -2.69 c -0.016 -1.186 -0.617 -1.787 -1.803 -1.803 c -1.188 -0.016 -2.084 -0.533 -2.691 -1.553 c -0.605 -1.02 -1.428 -1.24 -2.463 -0.66 s -2.07 0.58 -3.105 0 s -1.856 -0.359 -2.463 0.66 c -0.607 1.02 -1.503 1.537 -2.69 1.553 s -1.787 0.618 -1.803 1.804 c -0.016 1.187 -0.533 2.083 -1.553 2.69 s -1.24 1.428 -0.66 2.463 c 0.58 1.035 0.58 2.071 0 3.106 s -0.359 1.856 0.66 2.463 c 1.02 0.607 1.537 1.504 1.553 2.689 c 0.016 1.187 0.617 1.788 1.803 1.804 s 2.083 0.533 2.69 1.553 c 0.606 1.02 1.428 1.239 2.463 0.66 s 2.07 -0.579 3.105 0 s 1.857 0.359 2.463 -0.661 z z M 24.16 19.828 c -3.562 0.375 -2.838 1.256 -3.65 1.943 c -0.938 1 -2.107 0.807 -2.107 0.807 l 5.5 9.455 l 1.35 -3.5 l 3.846 0.5 l -4.939 -9.205 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalGold);
export default __webpack_public_path__ + "static/media/medal-gold.807e54928de7a50ef7a152ed1442ade9.svg";
export { ForwardRef as ReactComponent };